import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { REELS_BASE, reelsHomePath, reelsPath } from './paths';
import { resolveExperienceHubPath } from '../salon/utils/salonHomeNav';
import { isPresentationMode } from '../presentation/presentationSession';
import './styles/app.css';

function VideoNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const homePath = reelsHomePath();
  const isHome =
    pathname === homePath ||
    pathname === `${homePath}/` ||
    pathname === REELS_BASE ||
    pathname === `${REELS_BASE}/`;

  if (isHome) return null;

  return (
    <nav className="video-nav" aria-label="Reels capture">
      <button type="button" className="nav-btn nav-btn-back" onClick={() => navigate(-1)}>
        ← Back
      </button>
      <span className="video-nav-spacer" aria-hidden="true" />
      <button
        type="button"
        className="nav-btn nav-btn-home"
        onClick={() => navigate(isPresentationMode() ? resolveExperienceHubPath() : homePath)}
      >
        Home
      </button>
    </nav>
  );
}

export default function VideoFlowLayout() {
  return (
    <div className="naturals-video-shell">
      <div className="app-shell">
        <VideoNav />
        <Outlet />
      </div>
    </div>
  );
}

export { reelsPath, REELS_BASE };
